import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Field, formValueSelector } from "redux-form";
import { months } from "../../../../../../Utils/months";
import { renderDollar, renderCurrency, renderNumberKG, renderNumberKGDisabled, renderDollarDisabled, renderCurrencyDisabled } from "../../../../../../Utils/renderField/renderField";
import { symbol } from "prop-types";

const SkimTable = (props) => {

    const { change, skim_data, currency } = props;

    const data = skim_data || {};

    if (!data) {
        return null;
    }

    const calculateMonthlyValuesSkim = () => {
        var tempData = {};
        const getNumber = (v) => parseFloat(v) || 0;

        for (let i = 0; i < months.length; i++) {
            const month = months[i];
            const prevMonth = i > 0 ? months[i - 1] : null;

            if (!data[month]) continue;

            const current = data[month];
            const produccionMes = current.produccion_mes || {};
            const ajusteDelMes = current.ajuste_del_mes || {};
            const mermaPorProceso = current.merma_por_proceso || {};

            // Heredar inventario inicial
            let inventarioInicial = {};
            if (i === 0) {
                inventarioInicial = current.inventario_inicial || {};
            } else {
                const prevData = tempData[prevMonth] || data[prevMonth] || {};
                inventarioInicial = prevData.inventario_final || {};
            }

            const kgsSecos = (
                getNumber(inventarioInicial.kgs_secos) +
                getNumber(produccionMes.kgs_secos) -
                getNumber(ajusteDelMes.kgs_secos) -
                getNumber(mermaPorProceso.kgs_secos)
            ).toFixed(2);

            const valorTotal = (
                getNumber(inventarioInicial.valor_total) +
                getNumber(produccionMes.valor_total) -
                getNumber(ajusteDelMes.valor_total) -
                getNumber(mermaPorProceso.valor_total)
            ).toFixed(2);

            const costoPromedio = kgsSecos > 0 ? (valorTotal / kgsSecos).toFixed(5) : 0;

            const inventarioFinal = {
                kgs_secos: 0,
                valor_total: 0,
                costo_kg_seco: costoPromedio
            };

            tempData[month] = {
                inventario_inicial: {
                    kgs_secos: getNumber(inventarioInicial.kgs_secos),
                    costo_kg_seco: getNumber(inventarioInicial.costo_kg_seco),
                    valor_total: (getNumber(inventarioInicial.kgs_secos) * getNumber(inventarioInicial.costo_kg_seco)).toFixed(2)
                },
                ajuste_del_mes: {
                    valor_total: (getNumber(ajusteDelMes.kgs_secos) * getNumber(ajusteDelMes.costo_kg_seco)).toFixed(2)
                },
                merma_por_proceso: {
                    valor_total: (getNumber(mermaPorProceso.kgs_secos) * getNumber(mermaPorProceso.costo_kg_seco)).toFixed(2)
                },
                cto_promedio_del_inven: {
                    kgs_secos: kgsSecos,
                    valor_total: valorTotal,
                    costo_kg_seco: costoPromedio
                },
                salidas_a_produccion: {
                    kgs_secos: kgsSecos,
                    valor_total: 0,
                    costo_kg_seco: 0
                },
                inventario_final: inventarioFinal
            };
        }

        // Aplicar los cambios al formulario
        for (let i = 0; i < months.length; i++) {
            const month = months[i];
            const temp = tempData[month];

            if (!temp) continue;

            change(`skim_data.${month}.inventario_inicial.kgs_secos`, temp.inventario_inicial.kgs_secos);
            change(`skim_data.${month}.inventario_inicial.costo_kg_seco`, temp.inventario_inicial.costo_kg_seco);
            change(`skim_data.${month}.inventario_inicial.valor_total`, temp.inventario_inicial.valor_total);

            change(`skim_data.${month}.ajuste_del_mes.valor_total`, temp.ajuste_del_mes.valor_total);
            change(`skim_data.${month}.merma_por_proceso.valor_total`, temp.merma_por_proceso.valor_total);

            change(`skim_data.${month}.cto_promedio_del_inven.kgs_secos`, temp.cto_promedio_del_inven.kgs_secos);
            change(`skim_data.${month}.cto_promedio_del_inven.valor_total`, temp.cto_promedio_del_inven.valor_total);
            change(`skim_data.${month}.cto_promedio_del_inven.costo_kg_seco`, temp.cto_promedio_del_inven.costo_kg_seco);

            change(`skim_data.${month}.salidas_a_produccion.kgs_secos`, temp.salidas_a_produccion.kgs_secos);
            change(`skim_data.${month}.salidas_a_produccion.valor_total`, temp.salidas_a_produccion.valor_total);
            change(`skim_data.${month}.salidas_a_produccion.costo_kg_seco`, temp.salidas_a_produccion.costo_kg_seco);

            change(`skim_data.${month}.inventario_final.kgs_secos`, temp.inventario_final.kgs_secos);
            change(`skim_data.${month}.inventario_final.valor_total`, temp.inventario_final.valor_total);
            change(`skim_data.${month}.inventario_final.costo_kg_seco`, temp.inventario_final.costo_kg_seco);
        }

    };

    const rowDescriptionClassName = "text-left table-fixed-cell-left-0 bg-white text-nowrap tr--border-left tr--border-right";

    return (
        <div className="reports__table-bg">
            <div className="reports-table__container">
                <table className="table mb-0 text-center min-w-500">
                    <thead>
                        <tr>
                            <th rowSpan={2} className="text-left table-fixed-cell-left-0 tr--border-top tr--border-left td--shadow-right">&nbsp;</th>
                            {months.map((_, index) => (
                                <th key={index} colSpan={3} className={`th--border ${index === 0 ? "tr--no-border-left" : ""}`}>{index + 1}</th>
                            ))}
                        </tr>
                        <tr className="tr--no-radius tr--border-top">
                            {months.map((_, index) => (
                                <React.Fragment key={index}>
                                    <th className={index > 0 ? "tr--border-left" : ""}>Kgs Secos</th>
                                    <th>Costo Kg Sec</th>
                                    <th className="tr--border-right">Valor total</th>
                                </React.Fragment>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="tr--border-top">
                            <td className={rowDescriptionClassName}>Inventario Inicial</td>
                            {months.map((month, index) => {
                                const previousMonth = index > 0 ? months[index - 1] : null;
                                const monthClass = index % 2 === 0 ? " month-light" : " month-dark";
                                return (
                                    <React.Fragment key={index}>
                                        <td className={monthClass}>
                                            {index === 0 ? (
                                                <Field
                                                    name={`skim_data.${month}.inventario_inicial.kgs_secos`}
                                                    type="text"
                                                    component={renderNumberKG}
                                                    className="form-control"
                                                    placeholder='0.0 kg'
                                                    isReport
                                                    onBlur={calculateMonthlyValuesSkim}
                                                />
                                            ) : (
                                                <Field
                                                    name={`skim_data.${previousMonth}.inventario_final.kgs_secos`}
                                                    type="text"
                                                    component={renderNumberKGDisabled}
                                                    className="form-control"
                                                    placeholder='0.0 kg'
                                                />
                                            )}
                                        </td>
                                        <td className={monthClass}>
                                            {index === 0 ? (
                                                <Field
                                                    name={`skim_data.${month}.inventario_inicial.costo_kg_seco`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollar : renderCurrency}
                                                    className="form-control"
                                                    placeholder="$ 0.00"
                                                    decimalScale={5}
                                                    onBlur={calculateMonthlyValuesSkim}
                                                />
                                            ) : (
                                                <Field
                                                    name={`skim_data.${previousMonth}.inventario_final.costo_kg_seco`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                    className="form-control"
                                                    placeholder="$ 0.00"
                                                    decimalScale={5}
                                                />
                                            )}
                                        </td>
                                        <td className={monthClass + ' tr--border-right'}>
                                            {index === 0 ?
                                                (
                                                    <Field
                                                        name={`skim_data.${month}.inventario_inicial.valor_total`}
                                                        type="text"
                                                        component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                        className="form-control"
                                                        placeholder='$0.00'
                                                    />
                                                ) : (
                                                    <Field
                                                        name={`skim_data.${previousMonth}.inventario_final.valor_total`}
                                                        type="text"
                                                        component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                        className="form-control"
                                                        placeholder='$0.00'
                                                    />
                                                )
                                            }

                                        </td>
                                    </React.Fragment>
                                );
                            })}
                        </tr>
                        {[
                            { label: "(+) Del mes", key: "produccion_mes" },
                        ].map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                <td className={rowDescriptionClassName}>{row.label}</td>
                                {months.map((month, index) => {
                                    const monthClass = index % 2 === 0 ? " month-light" : " month-dark";
                                    return (
                                        <React.Fragment key={index}>
                                            <td className={monthClass}>
                                                <Field
                                                    name={`skim_data.${month}.${row.key}.kgs_secos`}
                                                    type="text"
                                                    component={renderNumberKGDisabled}
                                                    className="form-control"
                                                    placeholder='0.00'
                                                />
                                            </td>
                                            <td className={monthClass}>
                                                <Field
                                                    name={`skim_data.${month}.${row.key}.costo_kg_seco`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                    className="form-control"
                                                    placeholder='$0.00'
                                                    decimalScale={5}
                                                />
                                            </td>
                                            <td className={monthClass + ' tr--border-right'}>
                                                <Field
                                                    name={`skim_data.${month}.${row.key}.valor_total`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                    className="form-control"
                                                    placeholder='$0.00'
                                                />
                                            </td>
                                        </React.Fragment>
                                    )
                                })}
                            </tr>
                        ))}
                        {/* 🔹 Filas editables */}
                        {[
                            { label: "(-) Ajuste del mes", key: "ajuste_del_mes" },
                            { label: "(-) Merma por proceso", key: "merma_por_proceso" },
                        ].map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                <td className={rowDescriptionClassName}>{row.label}</td>
                                {months.map((month, index) => {
                                    const monthClass = index % 2 === 0 ? " month-light" : " month-dark";
                                    return (
                                        <React.Fragment key={index}>
                                            <td className={monthClass}>
                                                <Field
                                                    name={`skim_data.${month}.${row.key}.kgs_secos`}
                                                    type="text"
                                                    component={renderNumberKG}
                                                    className="form-control"
                                                    placeholder="kg 0.0"
                                                    isReport
                                                    onBlur={calculateMonthlyValuesSkim}
                                                />
                                            </td>
                                            <td className={monthClass}>
                                                <Field
                                                    name={`skim_data.${month}.${row.key}.costo_kg_seco`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollar : renderCurrency}
                                                    className="form-control"
                                                    placeholder="$ 0.00"
                                                    decimalScale={5}
                                                    onBlur={calculateMonthlyValuesSkim}
                                                />
                                            </td>
                                            <td className={monthClass + ' tr--border-right'}>
                                                <Field
                                                    name={`skim_data.${month}.${row.key}.valor_total`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                    className="form-control"
                                                    placeholder='$0.00'
                                                />
                                            </td>
                                        </React.Fragment>
                                    )
                                })}
                            </tr>
                        ))}
                        {/* 🔹 Filas calculadas */}
                        {[
                            { label: "Cto. Promedio del Inven.", key: "cto_promedio_del_inven", style: ' celda-totales' },
                            { label: "Salidas a producción", key: "salidas_a_produccion", style: '' },
                            { label: "Inventario Final", key: "inventario_final", style: ' celda-totales' }
                        ].map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                <td className={rowDescriptionClassName + (row.style || '')}>{row.label}</td>
                                {months.map((month, index) => {
                                    const monthClass = index % 2 === 0 ? " month-light" : " month-dark";
                                    return (
                                        <React.Fragment key={index}>
                                            <td className={row.style + monthClass}>
                                                <Field
                                                    name={`skim_data.${month}.${row.key}.kgs_secos`}
                                                    type="text"
                                                    component={renderNumberKGDisabled}
                                                    className="form-control"
                                                    placeholder='0.00'
                                                />
                                            </td>
                                            <td className={row.style + monthClass}>
                                                <Field
                                                    name={`skim_data.${month}.${row.key}.costo_kg_seco`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                    className="form-control"
                                                    placeholder='$0.00'
                                                    decimalScale={5}
                                                />
                                            </td>
                                            <td className={row.style + monthClass + ' tr--border-right'}>
                                                <Field
                                                    name={`skim_data.${month}.${row.key}.valor_total`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                    className="form-control"
                                                    placeholder='$0.00'
                                                />
                                            </td>
                                        </React.Fragment>
                                    )
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

const selector = formValueSelector("CostosMPForm");
const mapStateToProps = (state) => ({ skim_data: selector(state, 'skim_data') });

export default connect(mapStateToProps)(SkimTable);
